var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadarFinanciamentoAjustado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -3 75 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -2,
    width: 74,
    height: 52,
    rx: 14,
    fill: "#818cf8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272763",
    strokeWidth: 1,
    d: "M3,12.4v23.4c0,5.8,4.7,10.4,10.4,10.4-4.3,0-7.8-4.7-7.8-10.4V12.4c0-4.3,3.5-7.8,7.8-7.8h46.9c4.3,0,7.8,3.5,7.8,7.8v23.4c0,5.8-3.5,10.4-7.8,10.4,5.8,0,10.4-4.7,10.4-10.4V12.4c0-5.8-4.7-10.4-10.4-10.4H13.4C7.6,2,3,6.7,3,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272763",
    strokeWidth: 1,
    d: "M16,41.7c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v10.4c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3V41.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272763",
    strokeWidth: 1,
    d: "M28.1,23.5c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v28.6c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3V23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272763",
    strokeWidth: 1,
    d: "M40.3,32.6c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v19.5c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3V32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#272763",
    strokeWidth: 1,
    d: "M52.4,14.4c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v37.7c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3V14.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarFinanciamentoAjustado);
export default __webpack_public_path__ + "static/media/radar-financiamento-ajustado.3bc28296284eca1b705b0d5b85fdfe89.svg";
export { ForwardRef as ReactComponent };